import { Constant } from "@pdfking/tfunc"

import type { ElectronBridge as ElectronBridgeType } from "../electron/ElectronBridge"

/** The same surface as the electron build, so code shared by both can be typed
 * against it: there is no host bridge in a plain browser. */
export type ElectronBridge = ElectronBridgeType

/** A loud failure: nothing in a browser build should reach for the bridge
 * without asking ElectronQ first. */
export const ElectronBridge = (): ElectronBridge => {
  throw new Error("ElectronBridge: not running inside the Electron shell")
}

/** Never, by construction: this module is the browser build. */
export const ElectronQ = Constant(false) as () => boolean
